import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useUserID(): [string] {
  return [useWebChatAPIContext().userID];
}
